import React from 'react';

export const VideoThumbnail: React.FC<{
  videoUrl: string;
}> = ({ videoUrl }) => {
  const videoRef = React.useRef<HTMLVideoElement | null>(null);
  const [duration, setDuration] = React.useState<number | null>(null);

  const handleLoadedMetadata = () => {
    const video = videoRef.current;
    if (!video) return;

    setDuration(Math.floor(video.duration));
    const targetTime = Math.min(1, video.duration * 0.25);
    video.currentTime = targetTime;
  };

  return (
    <>
      <video
        muted
        ref={videoRef}
        src={videoUrl}
        controls={false}
        preload={'metadata'}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
        onLoadedMetadata={handleLoadedMetadata}
        crossOrigin={'anonymous'}
      />

      <div
        className={
          'd-flex align-items-center justify-content-center position-absolute'
        }
        style={{
          bottom: '8px',
          right: '8px',
          fontSize: '12px',
          borderRadius: '4px',
          padding: '4px 8px',
          backgroundColor: '#000000B2',
          color: 'white'
        }}>
        {duration ?? 0}s
      </div>
    </>
  );
};
